// extracted by mini-css-extract-plugin
export default {"background_bleed":"styles-module__background_bleed--nzEJd","content_wrapper":"styles-module__content_wrapper--RN4Vv","link":"styles-module__link--wLqpv"};